export default {
    getTicker
};

function getTicker(index) {
    return Nasdaq100[index];
}

const Nasdaq100 = [
    'Activision Blizzard',
    'Adobe Inc.',
    'Advanced Micro Devices',
    'Alexion Pharmaceuticals',
    'Align Technology',
    'Alphabet Inc. (Class A)',
    'Alphabet Inc. (Class C)',
    'Amazon.com',
    'Amgen',
    'Analog Devices',
    'ANSYS',
    'Apple Inc.',
    'Applied Materials, Inc.',
    'ASML Holding',
    'Autodesk',
    'Automatic Data Processing, Inc.',
    'Baidu',
    'Biogen',
    'BioMarin Pharmaceutical Inc.',
    'Booking Holdings',
    'Broadcom Inc.',
    'Cadence Design Systems',
    'CDW',
    'Cerner Corporation',
    'Charter Communications, Inc.',
    'Check Point Software Technologies Ltd.',
    'Cintas Corporation',
    'Cisco Systems',
    'Citrix Systems',
    'Cognizant Technology Solutions Corporation',
    'Comcast Corporation',
    'Copart',
    'Costco Wholesale Corporation',
    'CSX Corporation',
    'DexCom',
    'DocuSign',
    'Dollar Tree, Inc.',
    'eBay Inc.',
    'Electronic Arts',
    'Exelon Corporation',
    'Expedia Group',
    'Facebook, Inc.',
    'Fastenal Company',
    'Fiserv, Inc.',
    'Fox Corporation (Class A)',
    'Fox Corporation (Class B)',
    'Gilead Sciences, Inc.',
    'IDEXX Laboratories',
    'Illumina, Inc.',
    'Incyte Corporation',
    'Intel Corporation',
    'Intuit',
    'Intuitive Surgical',
    'JD.com',
    'KLA Corporation',
    'Kraft Heinz Co',
    'Lam Research',
    'Liberty Global (Class A)',
    'Liberty Global (Class C)',
    'Lululemon Athletica',
    'Marriott International',
    'Maxim Integrated Products',
    'MercadoLibre',
    'Microchip Technology',
    'Micron Technology, Inc.',
    'Microsoft Corporation',
    'Moderna',
    'Mondelēz International',
    'Monster Beverage Corporation',
    'NetEase, Inc.',
    'Netflix',
    'Nvidia Corporation',
    'NXP Semiconductors N.V.',
    'O\'Reilly Automotive, Inc.',
    'PACCAR Inc.',
    'Paychex, Inc.',
    'PayPal',
    'PepsiCo, Inc.',
    'Pinduoduo Inc.',
    'QUALCOMM',
    'Regeneron Pharmaceuticals',
    'Ross Stores Inc.',
    'Seattle Genetics',
    'Sirius XM Radio, Inc.',
    'Skyworks Solutions, Inc.',
    'Splunk	SPLK',
    'Starbucks Corporation',
    'Synopsys, Inc.',
    'T-Mobile US',
    'Take-Two Interactive, Inc.',
    'Tesla, Inc.',
    'Texas Instruments',
    'Trip.com Group',
    'Ulta Beauty',
    'Verisign',
    'Verisk Analytics',
    'Vertex Pharmaceuticals',
    'Walgreen Boots Alliance, Inc.',
    'Workday, Inc.',
    'Western Digital',
    'Xcel Energy, Inc.',
    'Xilinx, Inc.',
    'Zoom Video Communications',
]